import BigLogo from "@publicPortal/components/bigLogo/BigLogo";
import Board from "@publicPortal/components/board/Board";
import ResultBoard from "@publicPortal/components/resultBoard/ResultBoard";
import { PublicPortalRoutingService } from "@publicPortal/services/PublicPortalRoutingService";
import { UserService } from "@publicPortal/services/UserService";
import { memo, useState } from "react";
import ForgotPasswordBoilerplate from "@mirage/components/forgotPassword/ForgotPasswordBoilerplate";

const userService = new UserService();

const ForgotPassword = memo(() => {
    const [emailAddress, setEmailAddress] = useState("");
    const pp = new PublicPortalRoutingService();
    const [resultBoard, setResultBoard] = useState({
        show: false,
        isLoading: false,
        success: false,
        message: "",
    });

    return (
        <>
            <BigLogo />
            {resultBoard.show ? (
                <ResultBoard
                    loading={resultBoard.isLoading}
                    success={resultBoard.success}
                    message={resultBoard.message}
                    headerText={"Reset password"}
                    buttonLabel={"Back to Login"}
                    buttonNavTo={pp.LoginRoute()}
                >
                    {resultBoard.success ? (
                        <>
                            <b>{emailAddress}</b>
                            <p>Please check your inbox to continue.</p>
                        </>
                    ) : undefined}
                </ResultBoard>
            ) : (
                <Board headerText="Provide your email" size="small" className="forgotPasswordBoard">
                    <ForgotPasswordBoilerplate
                        service={userService}
                        emailAddress={emailAddress}
                        setEmailAddress={setEmailAddress}
                        setResultBoard={setResultBoard}
                        backButtonRoute={pp.LoginRoute()}
                        appName="publicportal"
                    />
                </Board>
            )}
        </>
    );
});

export default ForgotPassword;
